import type { FunctionComponent } from "react"
import { Col, Row } from "react-bootstrap"
import { useSelector } from "react-redux"
import { Route, Switch } from "react-router-dom" // Use 'react-router-dom' for Router-related imports
import ConfigureUsers from "src/components/admin/ConfigureUsers"
import ProtectedRoute from "src/components/common/ProtectedRoute"
import Container from "src/components/global/Container"
import SM2 from "src/components/global/menus/SM2/SM2"
import NavigationBar from "src/components/global/navigation_bar/NavigationBar"
import MyPto from "src/components/my_portal/MyPto/MyPto"
import EndpointSecurity from "src/pages/admin/endpoint/EndpointSecurity"
import RegisteredClients from "src/pages/admin/RegisteredClients"
import RoleManagement from "src/pages/admin/RoleManagement"
import RoleAndTemplateManagement from "src/pages/admin/RoleManagement_v3/RoleAndTemplateManagement"
import DailyReview from "src/pages/company_operations/DailyReview"
import PositiveResponseCodes from "src/pages/company_operations/PositiveResponseCodes/PositiveResponseCodes"
import TicketSearch from "src/pages/company_operations/TicketSearch"
import TimeAdministration from "src/pages/company_operations/time_administration/TimeAdministrastion"
import BillingGroupPricing from "src/pages/css/BillingGroupPricing/BillingGroupPricing"
import RevenueReport from "src/pages/css/Quickbooks/RevenueReport"
import Assignments from "src/pages/dispatch/Assignments"
import Rules from "src/pages/dispatch/Rules"
import DynamicForms from "src/pages/dynamic_forms/DynamicForms/DynamicForms"
import Fleet from "src/pages/fleet/Fleet"
import LeaseTracking from "src/pages/fleet/LeaseTracking/LeaseTracking"
import Employees from "src/pages/hr/Employees/Employees"
import HRSettings from "src/pages/hr/HRSettings/HRSettings"
import MyHr from "src/pages/hr/MyHr/MyHr"
import Permissions from "src/pages/hr/Permissions"
import HRReports from "src/pages/hr_reports/HRReports"
import Invoice from "src/pages/invoice/Invoice"
import ClientManagement from "src/pages/it_operations/ClientManagement"
import EditClient from "src/pages/it_operations/EditClient"
import PortalSessions from "src/pages/it_operations/PortalSessions"
import PositiveResponses from "src/pages/it_operations/positive_responses/PositiveResponses"
import Landing from "src/pages/landing/Landing"
import MyCalendar from "src/pages/my_portal/Calendar"
import Delegation from "src/pages/my_portal/Delegation"
import MyTasks from "src/pages/my_portal/MyTasks/MyTasks"
import Timesheet from "src/pages/my_portal/Timesheet"
import NotificationManagement from "src/pages/notification_management/NotificationManagement"
import PortalVideoLinkPlayer from "src/pages/portal_video_link_player/PortalVideoLinkPlayer"
import PTO from "src/pages/pto"
import ContractMaintenance from "src/pages/settings/css_Settings/contract_maintenance/ContractMaintenance"
import { FootageRestrictedLocateMaintenance } from "src/pages/settings/css_Settings/FootageRestrictedLocateMaintenance/FootageRestrictedLocateMaintenance"
import MemberCodeMaintenance from "src/pages/settings/css_Settings/MemberCodeMaintenance/MemberCodeMaintenance"
import VehicleMakeModel from "src/pages/settings/fleet_settings/VehicleMakeModel/VehicleMakeModel"
import JobTitleMaintenance from "src/pages/settings/human_resources_settings/JobTitleMaintenance/JobTitleMaintenance"
import PTOPlanMaintenance from "src/pages/settings/human_resources_settings/PTOPlanMaintenance/PTOPlanMaintenance"
import VehicleIncidents from "src/pages/vehicle_incidents/VehicleIncidents"
import "./Authenticated.css"

const Authenticated: FunctionComponent = () => {
	const features = useSelector((state: any) => state.features)
	return (
		<div className="Authenticated">
			<NavigationBar />
			<Container>
				<Row className="w-100" noGutters>
					<SM2 />
					<Switch>
						<Route exact path="/" render={() => <Landing />} />
						<Route
							path="/notifications"
							render={() => <NotificationManagement />}
						/>
						<Route
							path="/portal-video-player/:videoType/:objectId"
							render={() => <PortalVideoLinkPlayer />}
						/>
						<ProtectedRoute
							targets={["HR:ELEV", "HR:EXEC"]}
							path="/hr/admin/permissions"
							render={() => <Permissions />}
						/>
						<ProtectedRoute
							targets="PORTAL:EMPLOYEE-LIST-VIEWER"
							path="/hr/employees"
							render={() => <Employees />}
						/>
						<ProtectedRoute
							targets="HR:MYHR"
							path="/hr/my-hr"
							render={() => <MyHr />}
						/>
						<ProtectedRoute
							targets="HR:PTO"
							path="/hr/pto"
							render={() => <PTO />}
						/>
						<ProtectedRoute
							targets="HR:HRSETTINGS"
							path="/hr/settings"
							render={() => <HRSettings />}
						/>
						<ProtectedRoute
							targets="HR:ADMIN"
							path="/hr/reports"
							render={() => <HRReports />}
						/>
						<ProtectedRoute
							targets="PortalAdmin"
							path="/it/portal-sessions"
							render={() => <PortalSessions />}
						/>
						<ProtectedRoute
							targets="PortalAdmin"
							path="/it/user-roles-phantom"
							render={() => (
								<Col sm className="main-content">
									<ConfigureUsers />
								</Col>
							)}
						/>
						<ProtectedRoute
							exact
							targets="PortalAdmin"
							path="/it/client-management"
							render={() => <ClientManagement />}
						/>
						<ProtectedRoute
							targets="PortalAdmin"
							path="/it/client-management/:id?"
							render={() => <EditClient />}
						/>
						<ProtectedRoute
							targets="IT:PositiveResponse"
							path="/it/positive-responses"
							render={() => <PositiveResponses />}
						/>
						<ProtectedRoute
							targets="PortalAdmin"
							path="/role-management"
							render={() => <RoleAndTemplateManagement />}
						/>
						<ProtectedRoute
							targets="PortalAdmin"
							path="/role-management-phantom"
							render={() => <RoleManagement />}
						/>
						<ProtectedRoute
							targets="PortalAdmin"
							path="/registered-clients"
							render={() => <RegisteredClients />}
						/>
						<ProtectedRoute
							targets="PortalAdmin"
							path="/endpoint-security"
							render={() => <EndpointSecurity />}
						/>
						<ProtectedRoute
							targets="MYPORTAL:PTO"
							path="/my-portal/my-pto"
							render={() => <MyPto />}
						/>
						<ProtectedRoute
							targets="MYPORTAL"
							path="/my-portal/calendar"
							render={() => <MyCalendar />}
						/>
						<ProtectedRoute
							targets="MYPORTAL:TIMESHEET"
							path="/my-portal/timesheet/:entryDate?"
							render={() => <Timesheet />}
						/>
						<ProtectedRoute
							targets="MYPORTAL"
							path="/my-portal/my-tasks"
							render={() => <MyTasks />}
						/>
						<ProtectedRoute
							targets="MYPORTAL:DELEGATE"
							path="/my-portal/delegation"
							render={() => <Delegation />}
						/>
						<ProtectedRoute
							targets="COOP:TICKETSEARCH"
							path="/coop/ticket-search"
							render={(_p: any) => <TicketSearch />}
						/>
						<ProtectedRoute
							targets="COOP:TIMEADMIN"
							path="/hr/time-administration"
							render={(p: any) => <TimeAdministration {...p} />}
						/>
						<ProtectedRoute
							targets="PORTAL:EMPLOYEE-LIST-VIEWER"
							path="/coop/employees"
							render={() => <Employees />}
						/>
						<ProtectedRoute
							targets="COOP:PTO"
							path="/coop/pto"
							render={() => <PTO />}
						/>
						<ProtectedRoute
							targets="COOP:FORMS"
							path="/coop/dynamic-forms"
							render={() => <DynamicForms />}
						/>
						<ProtectedRoute
							targets="IP"
							exact
							path="/invoice"
							render={() => <Invoice />}
						/>
						<ProtectedRoute
							targets="CSS:ADMIN"
							path="/css/billing-group-pricing"
							render={() => <BillingGroupPricing />}
						/>
						<ProtectedRoute
							targets="CSS:ADMIN"
							path="/css/contract-maintenance"
							render={() => <ContractMaintenance />}
						/>
						<ProtectedRoute
							targets="CSS:ADMIN"
							path="/css/member-code-maintenance"
							render={() => <MemberCodeMaintenance />}
						/>
						<ProtectedRoute
							targets="CSS:ADMIN"
							path="/css/footage-restricted-locate-maintenance"
							render={() => <FootageRestrictedLocateMaintenance />}
						/>
						<ProtectedRoute
							targets="CSS:ADMIN"
							path="/css/revenue-report"
							render={() => <RevenueReport />}
						/>
						{features?.LeaseTracker && (
							<ProtectedRoute
								targets="FLEET:LEASEUSER"
								path="/fleet/lease-tracking"
								render={() => <LeaseTracking />}
							/>
						)}
						<ProtectedRoute
							path="/fleet/:filtername?"
							targets={["FLEET:USER", "FLEET:MA"]}
							render={() => <Fleet />}
						/>
						<ProtectedRoute
							path="/fleet-settings/make-model"
							targets={["FLEET:ADMIN"]}
							render={() => <VehicleMakeModel />}
						/>
						<ProtectedRoute
							path="/vehicle-incidents"
							targets={"Fleet:VehicleIncidents"}
							render={() => <VehicleIncidents />}
						/>
						<ProtectedRoute
							path="/hr-settings/pto-plan-maintenance"
							targets={["HR:ADMIN"]}
							render={() => <PTOPlanMaintenance />}
						/>
						<ProtectedRoute
							path="/hr-settings/job-title-maintenance"
							targets={["HR:ADMIN"]}
							render={() => <JobTitleMaintenance />}
						/>
						<ProtectedRoute
							targets="COOP:DAILYREVIEW"
							path="/coop/daily-review"
							render={(_p: any) => <DailyReview />}
						/>
						<ProtectedRoute
							targets="COOP:POSITIVERESPONSECODE"
							path="/coop/positive-response-codes"
							render={(_p: any) => <PositiveResponseCodes />}
						/>
						<ProtectedRoute
							targets="DispatchAssignments"
							path="/dispatch/assignments"
							render={() => <Assignments />}
						/>
						<ProtectedRoute
							targets="DispatchRules"
							path="/dispatch/rules"
							render={() => <Rules />}
						/>
						<Route path="*" render={() => <Landing />} />
					</Switch>
				</Row>
			</Container>
		</div>
	)
}

export default Authenticated
